import React, { useState, useEffect } from 'react';

const datasets = {
  petcare: {
    head: ['Pet Name', 'Animal', 'Food', 'Time Fed'],
    rows: [
      ['Bingo', 'Dog', 'Kibble', '8:00 AM'],
      ['Whiskers', 'Cat', 'Fish', '8:15 AM'],
      ['Tweety', 'Bird', 'Seeds', '7:45 AM'],
      ['Nibbles', 'Rabbit', 'Carrots', '9:00 AM'],
      ['Max', 'Dog', 'Chicken', '8:30 AM'],
    ],
    questions: [
      { q: 'Is Whiskers a Cat?', correct: 'yes' },
      { q: 'Does Tweety eat Carrots?', correct: 'no' },
      { q: 'Is Nibbles a Rabbit?', correct: 'yes' },
      { q: 'Was Max fed at 7:45 AM?', correct: 'no' },
    ],
  },
  weather: {
    head: ['City', 'Temperature', 'Weather', 'Clothing'],
    rows: [
      ['Mumbai', '32°C', 'Sunny', 'T-Shirt'],
      ['Shimla', '12°C', 'Snowy', 'Jacket'],
      ['Kochi', '28°C', 'Rainy', 'Raincoat'],
      ['Delhi', '35°C', 'Sunny', 'Cap'],
      ['Ooty', '18°C', 'Cloudy', 'Sweater'],
    ],
    questions: [
      { q: 'Do you wear a T-Shirt in Mumbai?', correct: 'yes' },
      { q: 'Is it snowy in Shimla?', correct: 'yes' },
      { q: 'Do you need a Raincoat in Delhi?', correct: 'no' },
      { q: 'Is Sweater suitable for Ooty?', correct: 'yes' },
    ],
  },
  movie: {
    head: ['Name', 'Favorite Genre', 'Snack', 'Start Time'],
    rows: [
      ['Mia', 'Action', 'Popcorn', '7:00 PM'],
      ['Arjun', 'Comedy', 'Nachos', '7:15 PM'],
      ['Luna', 'Sci-Fi', 'Chocolate', '6:45 PM'],
      ['Omar', 'Drama', 'Chips', '7:30 PM'],
      ['Zoe', 'Comedy', 'Popcorn', '7:00 PM'],
    ],
    questions: [
      { q: 'Does Luna like Sci-Fi movies?', correct: 'yes' },
      { q: 'Does Arjun eat Popcorn?', correct: 'no' },
      { q: "Is Omar's favorite genre Drama?", correct: 'yes' },
      { q: 'Does Zoe eat Nachos?', correct: 'no' },
    ],
  },
  sports: {
    head: ['Player', 'Sport', 'Team', 'Score'],
    rows: [
      ['Ravi', 'Cricket', 'Tigers', '80'],
      ['Anya', 'Badminton', 'Eagles', '2'],
      ['Leo', 'Football', 'Wolves', '1'],
      ['Maya', 'Basketball', 'Panthers', '15'],
      ['Tina', 'Tennis', 'Rockets', '3'],
    ],
    questions: [
      { q: 'Does Ravi play Cricket?', correct: 'yes' },
      { q: 'Is Maya in the Tigers team?', correct: 'no' },
      { q: 'Did Leo score 1 goal?', correct: 'yes' },
      { q: 'Does Tina play Badminton?', correct: 'no' },
    ],
  },
  space: {
    head: ['Planet', 'Moons', 'Type', 'Distance from Sun'],
    rows: [
      ['Mercury', '0', 'Rocky', '57M km'],
      ['Venus', '0', 'Rocky', '108M km'],
      ['Earth', '1', 'Rocky', '150M km'],
      ['Jupiter', '79', 'Gas Giant', '778M km'],
      ['Saturn', '82', 'Gas Giant', '1.4B km'],
    ],
    questions: [
      { q: 'Does Earth have 2 moons?', correct: 'no' },
      { q: 'Is Jupiter a Gas Giant?', correct: 'yes' },
      { q: 'Does Mercury have any moons?', correct: 'no' },
      { q: 'Is Saturn farther than Jupiter?', correct: 'yes' },
    ],
  },
  school: {
    head: ['Name', 'Subject', 'Grade', 'Teacher'],
    rows: [
      ['Sara', 'Math', 'A', 'Mr. Ram'],
      ['Tom', 'Science', 'B', 'Ms. Lila'],
      ['Amy', 'History', 'A', 'Mr. Roy'],
      ['Liam', 'English', 'C', 'Ms. Priya'],
      ['Eva', 'Art', 'A', 'Mrs. Das'],
    ],
    questions: [
      { q: 'Did Sara get an A in Math?', correct: 'yes' },
      { q: 'Is Mr. Roy a Science teacher?', correct: 'no' },
      { q: 'Did Liam get a B grade?', correct: 'no' },
      { q: 'Is Mrs. Das an Art teacher?', correct: 'yes' },
    ],
  },
};

const styles = {
  body: {
    fontFamily: "'Comic Sans MS', cursive, sans-serif",
    backgroundColor: '#fff0f5',
    textAlign: 'center',
    padding: 20,
  },
  heading: {
    color: '#ff69b4',
    fontSize: 32,
    marginBottom: 20,
  },
  select: {
    padding: 10,
    fontSize: 18,
    margin: 10,
    borderRadius: 10,
    border: '2px solid #ffb6c1',
  },
  button: {
    padding: 12,
    fontSize: 18,
    margin: 10,
    backgroundColor: '#ffb6c1',
    color: 'white',
    border: 'none',
    borderRadius: 12,
    cursor: 'pointer',
    boxShadow: '2px 2px 6px rgba(0,0,0,0.2)',
  },
  table: {
    width: '90%',
    margin: '20px auto',
    borderCollapse: 'collapse',
    backgroundColor: '#fff',
    borderRadius: 15,
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  th: {
    padding: 14,
    border: '2px solid #ffb6c1',
    backgroundColor: '#ff69b4',
    color: '#fff',
    fontSize: 16,
  },
  td: {
    padding: 14,
    border: '2px solid #ffb6c1',
    backgroundColor: '#ffe4e1',
    fontSize: 15,
  },
  question: {
    // backgroundColor: '#fff0f5',
    borderRadius: 20,
    padding: 20,
    margin: '30px auto',
    width: '85%',
    fontSize: 20,
    display: 'none',
    textAlign: 'left',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
  },
  questionActive: {
    display: 'block',
  },
  questionP: {
    fontWeight: 'bold',
    fontSize: 22,
    color: '#d63384',
  },
  label: {

    display: 'block',
    margin: '10px 0',
    fontSize: 18,
  },
  result: {
    fontWeight: 'bold',
    marginTop: 12,
    color: 'green',
    fontSize: 18,
  },
  resultWrong: {
    fontWeight: 'bold',
    marginTop: 12,
    color: 'red',
    fontSize: 18,
  },
};


function DatasetQuiz() {
  const [selectedDataset, setSelectedDataset] = useState('petcare');
  const [showDataset, setShowDataset] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [results, setResults] = useState({});

  useEffect(() => {
    // reset on dataset change
    setCurrentQuestionIndex(0);
    setAnswers({});
    setResults({});
    setShowDataset(false);
  }, [selectedDataset]);

  const dataset = datasets[selectedDataset];

  const handleAnswerChange = (questionKey, value) => {
    setAnswers((prev) => ({ ...prev, [questionKey]: value }));
    // reset result for this question on answer change
    setResults((prev) => {
      const copy = { ...prev };
      delete copy[questionKey];
      return copy;
    });
  };

  const checkAnswer = (questionKey, correctAnswer) => {
    if (!answers[questionKey]) {
      setResults((prev) => ({ ...prev, [questionKey]: { correct: false, message: 'Please select an answer!' } }));
      return;
    }
    if (answers[questionKey] === correctAnswer) {
      setResults((prev) => ({ ...prev, [questionKey]: { correct: true, message: '✅ Your prediction is correct!' } }));
    } else {
      setResults((prev) => ({ ...prev, [questionKey]: { correct: false, message: '❌ Your prediction is wrong!' } }));
    }
  };

  const nextQuestion = () => {
    if (currentQuestionIndex < dataset.questions.length - 1) {
      setCurrentQuestionIndex((i) => i + 1);
    }
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.heading}>📊 Dataset Quiz</h1>

      <label htmlFor="datasetSelect">Choose a Dataset:</label>
      <select
        id="datasetSelect"
        style={styles.select}
        value={selectedDataset}
        onChange={(e) => setSelectedDataset(e.target.value)}
      >
        {Object.keys(datasets).map((key) => (
          <option key={key} value={key}>
            {key === 'petcare'
              ? '🐾 Pet Care'
              : key === 'weather'
              ? '🌦️ Weather Wear'
              : key === 'movie'
              ? '🎬 Movie Snacks'
              : key === 'sports'
              ? '🏅 Sports Facts'
              : key === 'space'
              ? '🚀 Space Knowledge'
              : key === 'school'
              ? '🏫 School Subjects'
              : key}
          </option>
        ))}
      </select>

      <button style={styles.button} onClick={() => setShowDataset((s) => !s)}>
        {showDataset ? '🙈 Hide Dataset' : '👁️ View Dataset'}
      </button>

      <table style={{ ...styles.table, display: showDataset ? 'table' : 'none' }}>
        <thead>
          <tr>
            {dataset.head.map((h, i) => (
              <th key={i} style={styles.th}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataset.rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} style={styles.td}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {dataset.questions.map((question, i) => {
        const isActive = i === currentQuestionIndex;
        const questionKey = `q${i}`;
        const result = results[questionKey];
        return (
          <div
            key={i}
            style={{
              ...styles.question,
              ...(isActive ? styles.questionActive : {}),
            }}
          >
            <p style={styles.questionP}>
              Q{i + 1}: {question.q}
            </p>
            <label style={styles.label}>
              <input
                type="radio"
                name={questionKey}
                value="yes"
                checked={answers[questionKey] === 'yes'}
                onChange={() => handleAnswerChange(questionKey, 'yes')}
              />{' '}
              Yes
            </label>
            <label style={styles.label}>
              <input
                type="radio"
                name={questionKey}
                value="no"
                checked={answers[questionKey] === 'no'}
                onChange={() => handleAnswerChange(questionKey, 'no')}
              />{' '}
              No
            </label>
            <button
              onClick={() => checkAnswer(questionKey, question.correct)}
              style={{
                ...styles.button,
                backgroundColor: '#f4a261',
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              Submit
            </button>
            {result && (
              <div
                style={{
                  fontWeight: 'bold',
                  marginTop: 10,
                  color: result.correct ? 'green' : 'red',
                }}
              >
                {result.message}
              </div>
            )}
            {i < dataset.questions.length - 1 && (
              <button
                onClick={nextQuestion}
                style={{
                  ...styles.button,
                  backgroundColor: '#f4a261',
                  marginTop: 10,
                }}
              >
                Next ➡️
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default DatasetQuiz;
